<template>
  <div>
    <inventory-edit
      ref="inventoryEditRef"
      @save-success="editInventorySaveSuccess"
    />
    <div class="flex flex-col space-y-2.5">
      <div
        class="pa-10"
        v-if="authPermissions.has('inventory_monitoring:view')"
      >
        <div class="flex space-x-2.5 pt-2 items-center">
          <div>
            <v-text-field
              dense
              hide-details
              readonly
              label="Today Sales"
              outlined
              :value="todaySales"
            ></v-text-field>
          </div>
          <div>
            <v-text-field
              type="date"
              dense
              hide-details
              :value="mostSoldItemsDateRange[0]"
              @change="dateStartChange"
              outlined
              label="Date Start"
            ></v-text-field>
          </div>
          <div>
            <v-text-field
              type="date"
              dense
              hide-details
              :value="mostSoldItemsDateRange[1]"
              @change="dateEndChange"
              outlined
              label="Date End"
            ></v-text-field>
          </div>
          <div>
            <v-select
              label="No of Items."
              dense
              hide-details
              :items="[5, 6, 7, 8]"
              outlined
              v-model="mostSoldItemsLimit"
            ></v-select>
          </div>
          <v-btn color="primary" @click="getMostSoldItems()">Refresh</v-btn>
        </div>
        <div style="position: relative; height: 400px">
          <most-sold-items-chart
            ref="mostSoldItemsChartRef"
            :data="mostSoldItemsChartData"
            style="width: 100%; height: 100%; position: absolute"
          />
        </div>
      </div>
      <inventory-table
        v-if="authPermissions.has('inventory_monitoring:view')"
        ref="inventoryTableRef"
        @edit="editInventory"
      ></inventory-table>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import {
  ErrorPopup,
  firstDayOfMonth,
  formatAccounting,
  useWatchEffect,
} from '../../../lib/utils'
import appAxios from '../../../extra-functions/axios.extra'

const [watchEffect, clearWatchEffect] = useWatchEffect()

export default {
  name: 'InventoryMonitoring',
  components: {
    inventoryEdit: () =>
      import('@/views/dashboard/components/inventory-monitoring/InventoryEdit'),
    inventoryTable: () =>
      import(
        '@/views/dashboard/components/inventory-monitoring/InventoryTable'
      ),
    mostSoldItemsChart: () =>
      import('@/views/dashboard//component/MostSoldItemsChart.vue'),
  },
  data() {
    return {
      fetchingMostSoldItems: false,
      mostSoldItemsLimit: 5,
      mostSoldItemsDateRange: [firstDayOfMonth(), null],
      mostSoldItemsChartData: {
        labels: [],
        backgroundColor: [],
        data: [],
        datasetLabel: '',
      },
      todaySales: '0.00',
    }
  },
  computed: {
    ...mapState({
      axios: (state) => appAxios(state.auth.token),
      storeId: (state) => state.settings.storeId,
      authPermissions: (state) => state.auth.userPermissions,
    }),
  },
  created() {
    this.getTotalTodaySales()
  },
  mounted() {
    this.getMostSoldItems()
  },
  destroyed() {
    clearWatchEffect()
  },
  methods: {
    editInventory(inventoryId) {
      this.$refs?.inventoryEditRef?.open?.(inventoryId)
    },
    editInventorySaveSuccess() {
      this.$refs?.inventoryTableRef?.getIndex?.()
    },
    getMostSoldItems() {
      watchEffect(async (onCleanup) => {
        try {
          const controller = new AbortController()
          onCleanup(() => {
            controller.abort()
          })
          this.fetchingMostSoldItems = true
          const { data } = await this.axios.get(
            `/stocks/most-sold-items/${this.storeId}`,
            {
              params: {
                dateStart: this.mostSoldItemsDateRange[0],
                dateEnd: this.mostSoldItemsDateRange[1],
                limit: this.mostSoldItemsLimit,
              },
            },
          )
          this.mostSoldItemsChartData = {
            labels: data.labels,
            data: data.quantities,
            datasetLabel: data.dateRange,
            backgroundColor: data.colors,
          }
          this.$refs.mostSoldItemsChartRef.update()
        } catch (e) {
          console.error(e)
          this.$alertSwalError('oops something went wrong')
        } finally {
          this.fetchingMostSoldItems = false
        }
      }, 'getMostSoldItems')
    },
    dateStartChange(date) {
      this.mostSoldItemsDateRange[0] = date
      this.mostSoldItemsDateRange = [...this.mostSoldItemsDateRange]
    },
    dateEndChange(date) {
      this.mostSoldItemsDateRange[1] = date
      this.mostSoldItemsDateRange = [...this.mostSoldItemsDateRange]
    },
    async getTotalTodaySales() {
      try {
        const { data } = await this.axios.get(
          '/v2/sale-inventories/today-sales',
        )
        this.todaySales = formatAccounting(data)
      } catch (e) {
        if (process.env.NODE_ENV === 'development') {
          console.error(e)
        }
        ErrorPopup.fire({
          title: 'Error',
          text: 'Failed to fetch total today sales',
        })
      }
    },
  },
}
</script>
